// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

require('./modules/modal');
require('./modules/formInputs');

import Alpine from 'alpinejs';
import ScrollReveal from "scrollreveal";
import Swiper, { Autoplay, Navigation } from 'swiper';

window.Alpine = Alpine
Alpine.start()

ScrollReveal().reveal('.SlideDown', {
    distance: "-5%",
    duration: 500,
    opacity: 0,
    viewFactor: 0.1
});

const flexCards = document.querySelectorAll('.flexcards');
flexCards.forEach(card => {
    const relatedIconBlockLength = card.querySelectorAll('.iconblock').length;
    if (relatedIconBlockLength > 3) {
        card.classList.add('__slider');
    }
});

new Swiper('.flexcards.__slider', {
    modules: [Navigation],
    loop: false,
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 32,
    breakpoints: {
        769: {
            slidesPerView: 2,
        },
        1200: {
            slidesPerView: 3,
        },
    },
    navigation: {
        nextEl: '.flexcards__next',
        prevEl: '.flexcards__prev',
    },
});


const browser_width = window.innerWidth;
const introductionSlides = document.querySelector('.introduction__slides');
let introductionSlidesLength;

if (introductionSlides !== null) {
    introductionSlidesLength = introductionSlides.querySelectorAll('.iconblock').length;
}

if (browser_width < 1280 || introductionSlidesLength > 4) {
    // Triggering swiper if screen is less than 1280px or there are more than 4 elements
    if (introductionSlides !== null) {
        introductionSlides.classList.remove('__below');
    }
    new Swiper('.introduction__slides', {
        modules: [Navigation],
        loop: false,
        slidesPerView: 1,
        spaceBetween: 18,
        breakpoints: {
            769: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1400: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: '.introduction__next',
            prevEl: '.introduction__prev',
        },
    });
}
else if (introductionSlidesLength <= 4) {
    // Not triggering swiper if screen is larger than 1280px and there are 4 or fewer elements
    if (introductionSlides !== null) {
        introductionSlides.classList.add('__below');
    }
}
else {
    // Default behavior: triggering swiper
    if (introductionSlides !== null) {
        introductionSlides.classList.remove('__below');
    }
    new Swiper('.introduction__slides', {
        modules: [Navigation],
        loop: false,
        slidesPerView: 1,
        spaceBetween: 18,
        breakpoints: {
            769: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1400: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: '.introduction__next',
            prevEl: '.introduction__prev',
        },
    });
}

if (browser_width < 992) {
    new Swiper('.logoslider__disabled', {
        loop: true,
        centeredSlides: false,
        slidesPerView: 2,
        spaceBetween: 20,
        autoplay: false,
    });
}

new Swiper('.carouselcta__blocks', {
    modules: [Navigation],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 18,
    breakpoints: {
        769: {
            spaceBetween: 24,
        },
        1400: {
            slidesPerView: 2,
        },
    },
    navigation: {
        nextEl: '.carouselcta__next',
        prevEl: '.carouselcta__prev',
    },
});

new Swiper('.logoslider__slides', {
    modules: [Autoplay],
    loop: true,
    centeredSlides: false,
    slidesPerView: 2,
    spaceBetween: 20,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 4,
        },
        1200: {
            slidesPerView: 6
        }
    },
});

new Swiper('.footerlogos__slides', {
    modules: [Autoplay],
    loop: true,
    slidesPerView: 2,
    spaceBetween: 20,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 4,
        },
        1200: {
            slidesPerView: 6
        },
        1400: {
            slidesPerView: 7
        }
    },
});

new Swiper('.vacancies__blocks', {
    modules: [Navigation],
    loop: false,
    slidesPerView: 1,
    spaceBetween: 18,
    breakpoints: {
        640: {
            spaceBetween: 24,
        },
        992: {
            slidesPerView: 1,
        },
        1200: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
    },
    navigation: {
        nextEl: '.vacancies__next',
        prevEl: '.vacancies__prev',
    },
});

new Swiper('.logoslider__slides.__loop', {
    modules: [Autoplay],
    loop: true,
    centeredSlides: true,
    slidesPerView: 2,
    spaceBetween: 20,
    autoplay: {
        delay: 1000,
        disableOnInteraction: false,
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 4,
        },
        1200: {
            slidesPerView: 6
        }
    },
});

new Swiper('.blogcarousel__slides', {
    modules: [Navigation],
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
        567: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 27,
        },
        992: {
            slidesPerView: 4,
        },
        1200: {
            slidesPerView: 5,
        },
        1600: {
            slidesPerView: 6,
        }
    },
    navigation: {
        nextEl: '.blogcarousel__next',
        prevEl: '.blogcarousel__prev',
    },
});

new Swiper('.teamslider__slider', {
    modules: [Navigation],
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
        567: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 27,
        },
        992: {
            slidesPerView: 4,
        },
        1200: {
            slidesPerView: 5,
        },
        1600: {
            slidesPerView: 6,
        }
    },
    navigation: {
        nextEl: '.teamslider__next',
        prevEl: '.teamslider__prev',
    },
});

new Swiper('.timeline__slider', {
    modules: [Navigation],
    slidesPerView: 1.2,
    breakpoints: {
        768: {
            slidesPerView: 2.2,
        },
        992: {
            slidesPerView: 3.2,
        },
        1200: {
            slidesPerView: 4.2,
        },
        1600: {
            slidesPerView: 6.2,
        }
    },
    navigation: {
        nextEl: '.timeline__next',
        prevEl: '.timeline__prev',
    },
});

new Swiper('.imageslider__slider', {
    modules: [Navigation],
    slidesPerView: 1.2,
    spaceBetween: 12,
    loop: true,
    centeredSlides: true,
    breakpoints: {
        567: {
            spaceBetween: 27,
            slidesPerView: 1.2,
        },
        1200: {
            spaceBetween: 82,
            slidesPerView: 1.25,
        },
    },
    navigation: {
        nextEl: '.imageslider__next',
        prevEl: '.imageslider__prev',
    },
    on: {
        resize: function (container) {
            var slideWidth = (container.slides[0].swiperSlideSize);
            var controlsWrapper = document.querySelector(".imageslider__buttons");
            controlsWrapper.style.width = slideWidth + 164 + "px";
        }
    }
});

const clickScrollUpEls = document.querySelectorAll('.ClickScrollUp');
Array.from(clickScrollUpEls).forEach(el => {
    el.addEventListener('click', function (event) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});

const allModals = document.querySelectorAll('.modal');
if (allModals.length > 0) {
    allModals.forEach(modal => {
        const childVideo = modal.querySelector('.modal__video');
        const relatedOverlay = modal.querySelector('.modal__overlay');
        const closeButton = modal.querySelector('.modal__close');
        const pauseTriggers = [relatedOverlay, closeButton];

        pauseTriggers.forEach(trigger => {
            trigger.addEventListener('click', function () {
                childVideo.pause();
                childVideo.currentTime = 0;
            })
        });
    })
}